import { siteConfig } from '@/config/site'
import { siteSettings } from '@/store/siteSettings'

function formatLocalDate(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

/** 是否处于灰度模式（环境变量强制开启 或 命中哀悼日日期） */
export function isGrayscaleEnabled() {
  if (process.env.VUE_APP_GRAYSCALE_MODE === 'true') return true
  const config = siteSettings.config || siteConfig
  if (config.grayscaleMode) return true

  const dates = config.grayscaleDates || []
  if (!dates.length) return false

  const today = formatLocalDate(new Date())
  return dates.includes(today)
}

/** 在 html 根节点应用灰度样式，覆盖全站（含弹窗、下拉等挂载到 body 的组件） */
export function applyGrayscaleMode() {
  if (isGrayscaleEnabled()) {
    document.documentElement.classList.add('site-grayscale')
  } else {
    document.documentElement.classList.remove('site-grayscale')
  }
}
